import { api } from './client';

export type FeedbackType = 'feature' | 'bug' | 'other';
export type FeedbackStatus = 'open' | 'in_progress' | 'resolved' | 'closed';

export interface FeedbackRequest {
  id: string;
  requestNumber: string;
  type: FeedbackType;
  category: string | null;
  message: string;
  status: FeedbackStatus;
  createdAt: string;
  updatedAt: string;
}

export interface AdminFeedbackRequest extends FeedbackRequest {
  submitterEmail: string;
  companyName: string;
}

export const feedbackApi = {
  create: (body: { type: FeedbackType; category?: string; message: string }) =>
    api.post<{ requestNumber: string; status: FeedbackStatus }>('/feedback', body),
  listMine: () => api.get<FeedbackRequest[]>('/feedback/mine'),
  // Admin-only — every tenant's requests, guarded server-side by SuperAdminGuard.
  listAll: () => api.get<AdminFeedbackRequest[]>('/feedback'),
  updateStatus: (id: string, status: FeedbackStatus) =>
    api.patch<AdminFeedbackRequest>(`/feedback/${id}/status`, { status }),
};
